"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  items: {
    marginBottom: theme.spacing(2)
  },
  item: {
    display: 'flex'
  },
  itemIcon: {
    marginRight: theme.spacing(),
    color: theme.palette.primary.main
  },
  itemAccion: {
    color: theme.palette.primary.main
  },
  itemTexto: {
    alignSelf: 'center'
  },
  titulo: {
    "@media screen and (max-width: 600px)": {
      width: 250
    },
    "@media screen and (min-width: 600px) and (max-width: 960px)": {
      width: 500
    },
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
});

exports.default = _default;